import type { IconProps } from '../../types';

export const SpellCheckIcon = ({
  className,
  color = 'currentColor',
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M12.2168 15.0684C13.4326 15.0684 14.165 14.1992 14.165 12.7588V12.0557C14.165 10.6152 13.4375 9.75098 12.2363 9.75098C11.4941 9.75098 10.9082 10.0977 10.7373 10.6396H10.6738V7.9834H9.38477V15H10.6543V14.209H10.7178C10.9277 14.7412 11.4941 15.0684 12.2168 15.0684ZM11.7871 14.043C11.1279 14.043 10.6738 13.5254 10.6738 12.7637V12.1191C10.6738 11.2939 11.0938 10.7764 11.7725 10.7764C12.4561 10.7764 12.8467 11.2939 12.8467 12.1924V12.6416C12.8467 13.5303 12.4609 14.043 11.7871 14.043ZM6.2041 15.0781C6.9707 15.0781 7.40527 14.7217 7.61035 14.3408H7.66895V15H8.88477V11.5186C8.88477 10.2051 7.9375 9.73633 6.77539 9.73633C5.35449 9.73633 4.74902 10.4199 4.69043 11.2695H5.90625C5.96973 10.9473 6.21875 10.7178 6.74609 10.7178C7.27344 10.7178 7.61035 10.9668 7.61035 11.4893V11.9531H6.3457C5.14453 11.9531 4.5 12.5684 4.5 13.4961C4.5 14.4727 5.19336 15.0781 6.2041 15.0781ZM6.62402 14.1309C6.18457 14.1309 5.7793 13.8965 5.7793 13.4131C5.7793 13.0176 6.04785 12.7295 6.61914 12.7295H7.61035V13.2666C7.61035 13.7695 7.16602 14.1309 6.62402 14.1309ZM15.5209 14.6978C14.9439 14.2976 14.6211 13.6105 14.6211 12.7148V12.0654C14.6211 10.6445 15.5146 9.72656 16.9258 9.72656C18.2783 9.72656 19.0449 10.5469 19.0645 11.5332H17.8779C17.8389 11.1816 17.5947 10.7568 16.96 10.7568C16.2861 10.7568 15.915 11.2744 15.915 12.085V12.71C15.915 13.1778 16.0363 13.5441 16.2576 13.7769L15.5209 14.6978Z'
        fill={color}
      />
      <path
        d='M18.4685 13.4143C18.792 13.6731 18.8444 14.1451 18.5857 14.4685L14.5857 19.4685C14.4524 19.6351 14.2545 19.7371 14.0415 19.7489C13.8285 19.7606 13.6205 19.6812 13.4697 19.5303L10.9697 17.0303C10.6768 16.7374 10.6768 16.2626 10.9697 15.9697C11.2626 15.6768 11.7374 15.6768 12.0303 15.9697L13.9378 17.8772L17.4143 13.5315C17.6731 13.208 18.1451 13.1556 18.4685 13.4143Z'
        fill={color}
      />
    </svg>
  );
};

export default SpellCheckIcon;
